import React from 'react';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import {getDynamicOptionLabel} from '../utils/dynamicFields';

export default function DynamicFieldInput({field, value, error, onChange, disabled, language, className}) {
    const v = value || '';
    const isSelect = field.type === 'select';
    return (
        <>
            <FormControl margin="normal" className={className}
                         variant="outlined"
                         required={!!field.required}
                         disabled={!!disabled}
                         error={!!error}>
                {isSelect ? (
                    <Select
                        value={v}
                        displayEmpty
                        onChange={onChange}
                        input={<OutlinedInput name={`dynamic_${field.key}`}/>}
                    >
                        {!field.required && <MenuItem value="">—</MenuItem>}
                        {(field.options || []).map(opt => (
                            <MenuItem value={opt.value} key={opt.value}>
                                {getDynamicOptionLabel(opt, language)}
                            </MenuItem>
                        ))}
                    </Select>
                ) : (
                    <OutlinedInput
                        name={`dynamic_${field.key}`}
                        type={field.type === 'integer' ? 'number' : 'text'}
                        inputProps={field.type === 'integer' ? {step: 1} : {}}
                        value={v}
                        error={!!error}
                        onChange={onChange}
                    />
                )}
            </FormControl>
            {error && <p style={{color: 'red'}}>{error}</p>}
        </>
    );
}
